import { z } from 'zod';

export const loginSchema = z.object({
  dni: z
    .string()
    .regex(/^\d+$/, 'El DNI solo debe contener números'),
  password: z
    .string()
    .min(1, 'La contraseña es requerida'),
});

export const registerSchema = z.object({
  name: z
    .string()
    .min(2, 'El nombre debe tener al menos 2 caracteres')
    .max(50, 'El nombre no puede exceder 50 caracteres')
    .regex(/^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]+$/, 'El nombre solo debe contener letras'),
  lastname: z
    .string()
    .min(2, 'El apellido debe tener al menos 2 caracteres')
    .max(50, 'El apellido no puede exceder 50 caracteres')
    .regex(/^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]+$/, 'El apellido solo debe contener letras'),
  email: z
    .string()
    .email('Ingresa un correo electrónico válido')
    .min(1, 'El correo electrónico es requerido'),
  password: z
    .string()
    .min(8, 'La contraseña debe tener al menos 8 caracteres'),
  confirmPassword: z.string(),
  dni: z
    .string()
    .regex(/^\d+$/, 'El DNI solo debe contener números'),
  rol: z.enum(['POSTULANTE', 'SUPERVISOR', 'ADMIN', 'SISTEMAS'], {
    errorMap: () => ({ message: 'Seleccione un rol válido' }),
  }),
  supervisorId: z.string().optional(),
  termsAccepted: z.boolean().refine((val) => val === true, {
    message: 'Debes aceptar los términos y condiciones',
  }),
}).refine((data) => data.password === data.confirmPassword, {
  message: 'Las contraseñas no coinciden',
  path: ['confirmPassword'],
});

export const changePasswordSchema = z.object({
  currentPassword: z
    .string()
    .min(1, 'Ingresa tu contraseña actual'),
  newPassword: z
    .string()
    .min(8, 'La nueva contraseña debe tener al menos 8 caracteres'),
  confirmNewPassword: z.string(),
}).refine((data) => data.newPassword === data.confirmNewPassword, {
  message: 'Las contraseñas no coinciden',
  path: ['confirmNewPassword'],
}).refine((data) => data.currentPassword !== data.newPassword, {
  message: 'La nueva contraseña debe ser diferente a la actual',
  path: ['newPassword'],
});
